var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.profilePic)?_c('img',{class:_vm.imageClass,style:({
      'max-width': _vm.width,
      'max-height': _vm.height,
    }),attrs:{"alt":"Profile Picture","src":_vm.profilePic}}):_vm._e(),(!_vm.profilePic)?_c('div',{staticClass:"default-picture-container",class:_vm.imageClass},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'user-circle']}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }